var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSupportIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4,
    clipPath: "url(#clip0_899_293)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.33331 18.6667V14.6667C5.33331 11.8377 6.45712 9.12458 8.45751 7.12419C10.4579 5.12381 13.171 4 16 4C18.829 4 21.5421 5.12381 23.5425 7.12419C25.5428 9.12458 26.6666 11.8377 26.6666 14.6667V18.6667",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 25.333C24 27.5423 20.4187 29.333 16 29.333",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.33331 18.6667C5.33331 17.9594 5.61426 17.2811 6.11436 16.781C6.61446 16.281 7.29274 16 7.99998 16H9.33331C10.0406 16 10.7188 16.281 11.2189 16.781C11.719 17.2811 12 17.9594 12 18.6667V22.6667C12 23.3739 11.719 24.0522 11.2189 24.5523C10.7188 25.0524 10.0406 25.3333 9.33331 25.3333H7.99998C7.29274 25.3333 6.61446 25.0524 6.11436 24.5523C5.61426 24.0522 5.33331 23.3739 5.33331 22.6667V18.6667Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 18.6667C20 17.9594 20.281 17.2811 20.781 16.781C21.2811 16.281 21.9594 16 22.6667 16H24C24.7072 16 25.3855 16.281 25.8856 16.781C26.3857 17.2811 26.6667 17.9594 26.6667 18.6667V22.6667C26.6667 23.3739 26.3857 24.0522 25.8856 24.5523C25.3855 25.0524 24.7072 25.3333 24 25.3333H22.6667C21.9594 25.3333 21.2811 25.0524 20.781 24.5523C20.281 24.0522 20 23.3739 20 22.6667V18.6667Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_899_293"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupportIcon);
export default __webpack_public_path__ + "static/media/support-icon.ba4e99192cf6bb0b3d0dc9473555eb2a.svg";
export { ForwardRef as ReactComponent };